import React from 'react';
import { RootState, useAppSelector } from '../../../../../../store';
import { Button } from '../../../../../Utility/Button';

interface FormControlsProps {
    isLoading: boolean;
    isNew: boolean;
    onSubmit: () => void;
    onCancel: () => void;
}

const FormControls: React.FC<FormControlsProps> = ({ isLoading, isNew, onSubmit, onCancel }) => {
    const i18n = useAppSelector((state: RootState) => state.i18n.i18n);

    return (
        <div className="flex justify-end gap-4 pt-6">
            <Button variant="secondary" onClick={onCancel} disabled={isLoading}>
                {i18n.translate({ id: 'form.cancel', sourceName: 'OpenAPI' })}
            </Button>
            <Button onClick={onSubmit} disabled={isLoading}>
                {isLoading
                    ? i18n.translate({ id: 'form.saving', sourceName: 'OpenAPI' })
                    : isNew
                    ? i18n.translate({ id: 'form.create', sourceName: 'OpenAPI' })
                    : i18n.translate({ id: 'form.update', sourceName: 'OpenAPI' })}{' '}
            </Button>
        </div>
    );
};

export default FormControls;
